/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BulkMoveFolderDocumentsResponseData
 */
export interface BulkMoveFolderDocumentsResponseData {
  /**
   *
   * @type {boolean}
   * @memberof BulkMoveFolderDocumentsResponseData
   */
  success?: boolean
}

export function BulkMoveFolderDocumentsResponseDataFromJSON(json: any): BulkMoveFolderDocumentsResponseData {
  return BulkMoveFolderDocumentsResponseDataFromJSONTyped(json, false)
}

export function BulkMoveFolderDocumentsResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkMoveFolderDocumentsResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success') ? undefined : json['success']
  }
}

export function BulkMoveFolderDocumentsResponseDataToJSON(value?: BulkMoveFolderDocumentsResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    success: value.success
  }
}
